import { useState } from 'react';
import { IRecourrenceDTO } from '../../../../models/happy-code-api.model';

export default function useRecurrence() {
  const [isRecurring, setIsRecurring] = useState(false);
  const [isRecurrenceModalOpen, setRecurrenceModalOpen] = useState(false);
  const [recorrenciaDto, setRecorrenciaDto] = useState<IRecourrenceDTO>({ qtdRepetir: 0, qtdFrequencia: undefined });

  return {
    isRecurring,
    setIsRecurring,
    isRecurrenceModalOpen,
    setRecurrenceModalOpen,
    recorrenciaDto,
    setRecorrenciaDto,
  };
}
